import React from "react";
import PropTypes from "prop-types";
const TIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <path
      fill={color || "var(--color-easil-gray-x-dark)"}
      fillRule="evenodd"
      d="M11 2v16h1a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2h1V2H2v1a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V2h-7z"
    />
  </svg>
);
TIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default TIcon;
